import { animated, useTransition } from '@react-spring/web';
import { FC } from 'react';
import ReactModal from 'react-modal';

interface ModalProps {
    isOpen: boolean
    title: React.ReactNode
    subtitle?: React.ReactNode
    children?: React.ReactNode
    onRequestClose?: () => void
}

export const Modal: FC<ModalProps> = ({ isOpen, title, children, onRequestClose, subtitle }) => {
    const transitions = useTransition(isOpen, {
        from: {
            opacity: 0,
            transform: 'translate(-50%, -45%)',
        },
        enter: {
            opacity: 1,
            transform: 'translate(-50%, -50%)',
        },
        leave: {
            opacity: 0,
            transform: 'translate(-50%, -55%)',
        },
        config: { tension: 120, friction: 14, precision: 0.01 }
    })

    return transitions((style, item) => (
        <ReactModal
            isOpen={item}
            style={{
                overlay: {
                    backgroundColor: 'rgba(22, 47, 43, 0.6)',
                    zIndex: 9999,
                    opacity: style.opacity as any,
                },
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: style.transform as any,
                    padding: '24px',
                    backgroundColor: 'white',
                    border: 'none',
                    borderRadius: '24px',
                }
            }}
            closeTimeoutMS={170}
            overlayElement={(props, children) => <animated.div {...props}>{children}</animated.div>}
            contentElement={(props, children) => <animated.div {...props}>{children}</animated.div>}
            onRequestClose={onRequestClose}
        >
            <div className='relative'>
                <div className='flex flex-col w-full mb-5 min-w-[548px]'>
                    <div className='flex justify-between w-full items-center'>
                        <div className='font-medium font-mediumttf text-2xl'>
                            {title}
                        </div>
                        <button onClick={onRequestClose} className='w-[16.5px] h-[16.5px] flex items-center justify-center relative'>
                            <div className='h-[23px] absolute w-[2px] block bg-color-dark rounded-lg rotate-45'/>
                            <div className='h-[23px] absolute w-[2px] block bg-color-dark rounded-lg -rotate-45'/>
                        </button>
                    </div>
                    <div className='text-sm text-color-gray -mt-1'>
                        {subtitle}
                    </div>
                </div>
                <div className='max-h-[80vh] overflow-y-auto'>
                    {children}
                </div>
            </div>
        </ReactModal>
    ))
}